module.exports = __webpack_public_path__ + "static/img/promotion2.2261d114.png";